import React, { useCallback, useEffect, useState } from "react";
import CookieBar from "../components/CookieBar";
import NavDesktop from "./NavDesktop";
import NavMobile from "./NavMobile";

const breakpoint = "(max-width:768px)";

function useTracking() {
	const key = "_tracking";
	const [tracking, setTracking] = useState<number | undefined>(0);

	useEffect(() => {
		const ls = localStorage.getItem(key);
		const v = ls === null ? undefined : parseInt(ls);
		setTracking(v);
	}, []);

	const update = useCallback(
		(newValue?: number) => {
			if (newValue === undefined) {
				localStorage.removeItem(key);
			} else {
				localStorage.setItem(key, newValue.toString());
			}
			setTracking(newValue);
		},
		[tracking],
	);

	return [tracking, update] as const;
}

const Nav: React.FC<React.HTMLAttributes<HTMLElement>> = ({ className }) => {
	const [isMobile, setIsMobile] = useState(false);
	const [tracking, setTracking] = useTracking();

	useEffect(() => {
		const onResize = (): void => {
			setIsMobile(matchMedia(breakpoint).matches);
		};
		addEventListener("resize", onResize);
		onResize();
		return () => {
			removeEventListener("resize", onResize);
		};
	}, [isMobile]);

	return (
		<>
			<CookieBar show={tracking === undefined} onChange={setTracking} />
			{isMobile ? (
				<NavMobile className={className} />
			) : (
				<NavDesktop className={className} />
			)}
		</>
	);
};

export default Nav;
